import React, {
  useEffect,
  useRef,
  useState,
  Suspense,
  lazy,
  useMemo,
} from "react";

import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Typography,
  Snackbar,
  Alert as MuiAlert,
  CircularProgress,
  Backdrop,
} from "@mui/material";


import Layout from "../../layout/Layout";

import {
  agentDashboardAPI,
  userDashboardAPI,
  config,
  statusAPI,
  usersAPI,
  userData,
} from "../../config";

import { Search } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment/moment";
import * as XLSX from "xlsx/xlsx.mjs";
import { MaterialReactTable } from "material-react-table";
const Pagination = lazy(() => import("../../components/ReactPagination"));

let intOffset = 0;

const stateList = [
  { state_name: `Andhra Pradesh` },
  { state_name: `Andaman and Nicobar Islands` },
  { state_name: `Arunachal Pradesh` },
  { state_name: `Assam` },
  { state_name: `Bihar` },
  { state_name: `Chandigarh` },
  { state_name: `Chhattisgarh` },
  { state_name: `Dadar and Nagar Haveli` },
  { state_name: `Daman and Diu` },
  { state_name: `Delhi` },
  { state_name: `Lakshadweep` },
  { state_name: `Puducherry` },
  { state_name: `Goa` },
  { state_name: `Gujarat` },
  { state_name: `Haryana` },
  { state_name: `Himachal Pradesh` },
  { state_name: `Jammu and Kashmir` },
  { state_name: `Jharkhand` },
  { state_name: `Karnataka` },
  { state_name: `Kerala` },
  { state_name: `Madhya Pradesh` },
  { state_name: `Maharashtra` },
  { state_name: `Manipur` },
  { state_name: `Meghalaya` },
  { state_name: `Mizoram` },
  { state_name: `Nagaland` },
  { state_name: `Odisha` },
  { state_name: `Punjab` },
  { state_name: `Rajasthan` },
  { state_name: `Sikkim` },
  { state_name: `Tamil Nadu` },
  { state_name: `Telangana` },
  { state_name: `Tripura` },
  { state_name: `Uttar Pradesh` },
  { state_name: `Uttarakhand` },
  { state_name: `West Bengal` },
];
function MuiSelect(props) {
  return (
    <FormControl fullWidth>
      <InputLabel id={props.label}>{props.label}</InputLabel>
      <Select
        labelId={props.label}
        id="demo-simple-select-helper"
        value={props.field}
        label={props.label}
        onChange={props.handleChange}
        name="ddlType"
      >
        {props.data.map((row, index) => (
          <MenuItem value={row.id} key={index}>
            {row.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

let field = "id",
  orderBy = "desc";

export default function Report() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [exportSuccess, setExportSuccess] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);

  const [checked, setChecked] = useState([0]);

  const handleToggle1 = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const [ticketList, setTicketList] = useState([]);

  const formatAdminTime = (timeStr) => {
    if (!timeStr || timeStr === "0 day 0 hour 0 min 0 sec") return "-";
    return timeStr
      .replace(/\b0 day\b ?/g, "")
      .replace(/\b0 hour\b ?/g, "")
      .replace(/\b0 min\b ?/g, "")
      .replace(/\b0 sec\b ?/g, "")
      .trim();
  };

  // FILTER START
  const [issueType, setIssueType] = useState("");
  const [issueSubType, setIssueSubType] = useState("");
  const [department, setDepartment] = useState("");
  const [prioritization, setPrioritization] = useState("");
  const [txtLGroup, settxtLGroup] = useState("");
  const [txtBranch, setBranch] = useState("");
  const [txtState, setState] = useState("");
  const [statusID, setStatusID] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [issueTypeList, setIssueTypeList] = useState([]);
  const [issueSubTypeList, setIssueSubTypeList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [prioritizationList, setPrioritizationList] = useState([]);
  const [locationGroup, setLocationGroup] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [statusList, setStatusList] = useState([]),
    [userList, setUserList] = useState([]),
    [repeatedTicketStatusList, setrepeatedTicketStatusList] = useState([]),
    [repeatedTicketStatusID, setrepeatedTicketStatusID] = useState(0),
    [userID, setUserID] = useState(0);

  // MRT State
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // State for applied external filters (to be updated only on Search click)
  const [appliedExternalFilters, setAppliedExternalFilters] = useState({
    issueType: "",
    issueSubType: "",
    department: "",
    prioritization: "",
    txtLGroup: "",
    txtBranch: "",
    txtState: "",
    statusID: "",
    repeatedTicketStatusID: 0,
    userID: 0,
    txtFromDate: "",
    txtToDate: "",
  });

  const downloadExcel = () => {
    setExcelLoading(true);

    // Map MRT filters to API parameters
    const filterTicketID = columnFilters.find(f => f.id === 'ticketID')?.value || null;
    const filterSubject = columnFilters.find(f => f.id === 'ticketSubject')?.value || null;
    const filterEmpNo = columnFilters.find(f => f.id === 'emp_no')?.value || null;
    const filterEmpName = columnFilters.find(f => f.id === 'emp_name')?.value || null;
    const filterCategory = columnFilters.find(f => f.id === 'ticketCategory')?.value || null;
    const filterSubCategory = columnFilters.find(f => f.id === 'sub_category')?.value || null;
    const filterStatusName = columnFilters.find(f => f.id === 'statusName')?.value || null;
    const filterReview = columnFilters.find(f => f.id === 'review')?.value || null;
    const filterPrioritization = columnFilters.find(f => f.id === 'Prioritization')?.value || null;
    const filterAgentName = columnFilters.find(f => f.id === 'agent_name')?.value || null;
    const filterLastReplyDate = columnFilters.find(f => f.id === 'lastAgentReplyDate')?.value || null;
    const filterAdminTime = columnFilters.find(f => f.id === 'admin_time')?.value || null;

    // Map MRT sorting
    const sortBy = sorting.length > 0 ? sorting[0].id : 'ticketID';
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? 'DESC' : 'ASC') : 'DESC';

    const data = JSON.stringify({
      intAgentID: userData.role === "agent" ? userData.id : null,
      intLimit: 0, // Fetch all for export
      intOffset: 0,
      intSPType: 15,
      intCategory: appliedExternalFilters.issueType,
      intSubCategory: appliedExternalFilters.issueSubType,
      intDepartment: appliedExternalFilters.department,
      intPrioritization: appliedExternalFilters.prioritization,
      txtLocationGroup: appliedExternalFilters.txtLGroup,
      txtState: appliedExternalFilters.txtState,
      txtBranch: appliedExternalFilters.txtBranch,
      intStatusID: appliedExternalFilters.statusID,
      intTicketID: appliedExternalFilters.repeatedTicketStatusID,
      intUserID:
        userData.role === "agent" || userData.role === "Admin"
          ? appliedExternalFilters.userID
          : userData.id,
      txtSearch: globalFilter,
      txtField: sortBy,
      txtOrderBy: sortOrder,
      txtFromDate: appliedExternalFilters.txtFromDate,
      txtToDate: appliedExternalFilters.txtToDate,
      filterTicketID,
      filterSubject,
      filterEmpNo,
      filterEmpName,
      filterCategory,
      filterSubCategory,
      filterStatusName,
      filterPrioritization,
      filterAgentName,
      filterLastReplyDate,
      filterAdminTime,
    });
    config.method = "PATCH";
    config.data = data;
    config.url =
      userData.role === "agent" || userData.role === "Admin"
        ? agentDashboardAPI
        : userDashboardAPI;
    axios(config)
      .then(function (response) {
        const newData = response.data["data"].map((row) => {
          delete row.year;
          delete row.month;
          delete row.day;
          delete row.hour;
          delete row.minute;
          delete row.second;
          delete row.ago;
          delete row.statusID;
          delete row.ticketID;
          delete row.tableData;

          row.created_at = moment(row.created_at).format(
            "ddd, DD MMM Y, hh:mm A"
          );
          row.admin_time = formatAdminTime(row.admin_time);
          row.agent_name = row.agent_name || "-";
          row.lastAgentReplyDate = row.lastAgentReplyDate || "-";
          return row;
        });

        console.log(newData);
        const workSheet = XLSX.utils.json_to_sheet(newData);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "students");
        //Buffer
        let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        //Binary string
        XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(
          workBook,
          `RTS-${moment().format("ddd, DD MMM Y, hh:mm A")}.xlsx`
        );
        setExcelLoading(false);
        setExportSuccess(true);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setExcelLoading(false);
      });
  };

  useEffect(() => {
    fetchData(pagination.pageIndex + 1, pagination.pageSize);
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, sorting, columnFilters, appliedExternalFilters]);

  const options = stateList.map((option) => {
    const firstLetter = option.state_name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });


  let filterUseRef = useRef(false);

  useEffect(() => {
    if (filterUseRef.current === false) {
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      getStatus(data, "issueTypeList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: 176,
      });
      getStatus(data, "setrepeatedTicketStatusList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "35",
      });
      getStatus(data, "departmentList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "33",
      });
      getStatus(data, "prioritizationList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "43",
      });
      getStatus(data, "statusList");

      data = JSON.stringify({
        intSubType: 0,
        txtAssets: "",
      });

      getUsers(data);

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "82",
      });
      getStatus(data, "setLocationGroup");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "100",
      });
      getStatus(data, "setBranchList");

      return () => {
        filterUseRef.current = true;
      };
    }
  }, []);

  const getUsers = (data) => {
    config.method = "PATCH";
    config.data = data;
    config.url = usersAPI;

    axios(config)
      .then(function (response) {
        setUserList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleIssueTypeChange = (e) => {
    setIssueType(e.target.value);
    const data = JSON.stringify({
      limit: 0,
      offset: 0,
      parent_id: e.target.value,
    });
    getStatus(data, "issueSubTypeList");
  };

  const handleIssueSubTypeChange = (e) => {
    setIssueSubType(e.target.value);
  };
  const handleStatusListChange = (e) => {
    setStatusID(e.target.value);
  };

  const handleDepartmentListChange = (e) => {
    setDepartment(e.target.value);
  };

  const viewMore = () => {
    intOffset = intOffset + limit;
    fetchData(2);
  };

  const fetchData = (page, size = pagination.pageSize) => {
    setLoading(true);

    // Map MRT filters to API parameters
    const filterTicketID = columnFilters.find(f => f.id === 'ticketID')?.value || null;
    const filterSubject = columnFilters.find(f => f.id === 'ticketSubject')?.value || null;
    const filterEmpNo = columnFilters.find(f => f.id === 'emp_no')?.value || null;
    const filterEmpName = columnFilters.find(f => f.id === 'emp_name')?.value || null;
    const filterCategory = columnFilters.find(f => f.id === 'ticketCategory')?.value || null;
    const filterSubCategory = columnFilters.find(f => f.id === 'sub_category')?.value || null;
    const filterStatusName = columnFilters.find(f => f.id === 'statusName')?.value || null;
    const filterPrioritization = columnFilters.find(f => f.id === 'Prioritization')?.value || null;
    const filterAgentName = columnFilters.find(f => f.id === 'agent_name')?.value || null;
    const filterLastReplyDate = columnFilters.find(f => f.id === 'lastAgentReplyDate')?.value || null;
    const filterAdminTime = columnFilters.find(f => f.id === 'admin_time')?.value || null;

    // Map MRT sorting
    const sortBy = sorting.length > 0 ? sorting[0].id : 'ticketID';
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? 'DESC' : 'ASC') : 'DESC';

    const data = JSON.stringify({
      intAgentID: userData.role === "agent" ? userData.id : null,
      intLimit: size,
      intOffset: (page - 1) * size,
      intSPType: 15,
      intCategory: appliedExternalFilters.issueType,
      intSubCategory: appliedExternalFilters.issueSubType,
      intDepartment: appliedExternalFilters.department,
      intPrioritization: appliedExternalFilters.prioritization,
      txtLocationGroup: appliedExternalFilters.txtLGroup,
      txtState: appliedExternalFilters.txtState,
      txtBranch: appliedExternalFilters.txtBranch,
      intStatusID: appliedExternalFilters.statusID,
      intTicketID: appliedExternalFilters.repeatedTicketStatusID,
      intUserID:
        userData.role === "agent" || userData.role === "Admin"
          ? appliedExternalFilters.userID
          : userData.id,
      txtSearch: globalFilter,
      txtField: sortBy,
      txtOrderBy: sortOrder,
      txtFromDate: appliedExternalFilters.txtFromDate,
      txtToDate: appliedExternalFilters.txtToDate,
      filterTicketID,
      filterSubject,
      filterEmpNo,
      filterEmpName,
      filterCategory,
      filterSubCategory,
      filterStatusName,
      filterPrioritization,
      filterAgentName,
      filterLastReplyDate,
      filterAdminTime,
    });

    config.method = "PATCH";
    config.data = data;
    config.url =
      userData.role === "agent" || userData.role === "Admin"
        ? agentDashboardAPI
        : userDashboardAPI;
    axios(config)
      .then(function (response) {
        setTicketList(response.data["data"]);
        setTotalRows(Math.round(response.data.count));
        setLoading(false);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setLoading(false);
      });
  };

  const getStatus = (data, type) => {
    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
        else if (type === "issueSubTypeList")
          setIssueSubTypeList(response.data["data"]);
        else if (type === "departmentList")
          setDepartmentList(response.data["data"]);
        else if (type === "prioritizationList")
          setPrioritizationList(response.data["data"]);
        else if (type === "statusList") setStatusList(response.data["data"]);
        else if (type === "setLocationGroup")
          setLocationGroup(response.data["data"]);
        else if (type === "setBranchList") setBranchList(response.data["data"]);
        else if (type === "setrepeatedTicketStatusList")
          setrepeatedTicketStatusList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handlePrioritizationListChange = (e) => {
    setPrioritization(e.target.value);
  };

  // FILTER END


  return (
    <Layout>
      {/* Full-page overlay loader for Excel export */}
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={excelLoading}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Exporting Excel...
        </Typography>
      </Backdrop>

      <Snackbar
        open={exportSuccess}
        autoHideDuration={3000}
        onClose={() => setExportSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert elevation={6} variant="filled" severity="success" onClose={() => setExportSuccess(false)}>
          Excel file exported successfully!
        </MuiAlert>
      </Snackbar>

      <div className={`background--white`}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              id="type-autocomplete"
              options={issueTypeList}
              getOptionLabel={(option) => option.name || ""}
              value={issueTypeList.find(i => i.id === issueType) || null}
              onChange={(event, newValue) => {
                const val = newValue ? newValue.id : "";
                setIssueType(val);
                const data = JSON.stringify({ limit: 0, offset: 0, parent_id: val });
                getStatus(data, "issueSubTypeList");
              }}
              renderInput={(params) => <TextField {...params} label="Type" variant="outlined" />}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              id="issue-type-autocomplete"
              options={issueSubTypeList}
              getOptionLabel={(option) => option.name || ""}
              value={issueSubTypeList.find(i => i.id === issueSubType) || null}
              onChange={(event, newValue) => setIssueSubType(newValue ? newValue.id : "")}
              renderInput={(params) => <TextField {...params} label="Issue Type" variant="outlined" />}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              id="department-autocomplete"
              options={departmentList}
              getOptionLabel={(option) => option.name || ""}
              value={departmentList.find(d => d.id === department) || null}
              onChange={(event, newValue) => setDepartment(newValue ? newValue.id : "")}
              renderInput={(params) => <TextField {...params} label="Department" variant="outlined" />}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              id="prioritization-autocomplete"
              options={prioritizationList}
              getOptionLabel={(option) => option.name || ""}
              value={prioritizationList.find(p => p.id === prioritization) || null}
              onChange={(event, newValue) => setPrioritization(newValue ? newValue.id : "")}
              renderInput={(params) => <TextField {...params} label="Prioritisation" variant="outlined" />}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              id="status-autocomplete"
              options={statusList}
              getOptionLabel={(option) => option.name || ""}
              value={statusList.find(s => s.id === statusID) || null}
              onChange={(event, newValue) => setStatusID(newValue ? newValue.id : "")}
              renderInput={(params) => <TextField {...params} label="Ticket Status" variant="outlined" />}
              fullWidth
            />
          </Grid>

          {userData.role === "user" ? (
            <></>
          ) : (
            <Grid item xs={12} lg={3} md={3}>
              <FormControl className={`form-control`} fullWidth>
                <Autocomplete
                  id="combo-box-demo"
                  options={userList}
                  getOptionLabel={(option) =>
                    option.emp_no + " - " + option.username
                  }
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="User" variant="outlined" />
                  )}
                  onChange={(event, newValue) => {
                    setUserID(0);
                    if (newValue !== null) {
                      setUserID(newValue.id);
                    }
                  }}
                />
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} lg={3} md={3}>
            <FormControl className={`form-control`} fullWidth>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={locationGroup}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Location Group"
                    placeholder="Location Group"
                  />
                )}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  settxtLGroup("");
                  if (newValue !== null) {
                    let temp = "";
                    for (let i = 0; i < newValue.length; i++) {
                      temp += newValue[i].name + ",";
                    }
                    temp = temp.substring(0, temp.length - 1);
                    settxtLGroup(temp);
                  }
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={branchList}
              getOptionLabel={(option) => option.name}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField {...params} label="Branch" placeholder="Branch" />
              )}
              onChange={(event, newValue) => {
                console.log(newValue);
                setBranch("");
                if (newValue !== null) {
                  let temp = "";
                  for (let i = 0; i < newValue.length; i++) {
                    temp += newValue[i].name + ",";
                  }
                  temp = temp.substring(0, temp.length - 1);
                  setBranch(temp);
                }
              }}
            />
          </Grid>

          <Grid item xs={12} lg={3} md={3}>
            <FormControl className={`form-control`} fullWidth>
              <Autocomplete
                id="combo-box-demo"
                options={options}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option.state_name}
                fullWidth
                renderInput={(params) => (
                  <TextField {...params} label="State" variant="outlined" />
                )}
                onChange={(event, newValue) => {
                  if (newValue !== null) {
                    setState(newValue.state_name);
                  }
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <Autocomplete
              id="repeated-status-autocomplete"
              options={repeatedTicketStatusList}
              getOptionLabel={(option) => option.name || ""}
              value={repeatedTicketStatusList.find(r => r.id === repeatedTicketStatusID) || null}
              onChange={(event, newValue) => setrepeatedTicketStatusID(newValue ? newValue.id : 0)}
              renderInput={(params) => <TextField {...params} label="Repeated Ticket Status" variant="outlined" />}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} lg={3} md={3}>
            <div className="date-picker-container" style={{ width: '100%' }}>
              <DatePicker
                selectsRange={true}
                startDate={fromDate ? new Date(fromDate) : null}
                endDate={toDate ? new Date(toDate) : null}
                onChange={(update) => {
                  const [start, end] = update;
                  setFromDate(start ? moment(start).format("YYYY-MM-DD") : "");
                  setToDate(end ? moment(end).format("YYYY-MM-DD") : "");
                }}
                isClearable={true}
                placeholderText="Select Date Range"
                className="custom-date-picker"
                dateFormat="yyyy-MM-dd"
                portalId="root"
              />
            </div>
          </Grid>

          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            textAlign={`center`}
            display={`flex`}
            justifyContent={`center`}
            gap={`10px`}
          >
            <Button
              className="btn-primary"
              onClick={() => {
                setAppliedExternalFilters({
                  issueType,
                  issueSubType,
                  department,
                  prioritization,
                  txtLGroup,
                  txtBranch,
                  txtState,
                  statusID,
                  repeatedTicketStatusID,
                  userID,
                  txtFromDate: fromDate,
                  txtToDate: toDate,
                });
                setPagination(prev => ({ ...prev, pageIndex: 0 }));
              }}
              startIcon={<Search />}
            >
              Search
            </Button>

            <Button
              className="btn-primary"
              onClick={() => {
                if (userData.role == "user") {
                  navigate("/user/ticket/report");
                } else if (
                  userData.role === "agent" ||
                  userData.role === "Admin"
                ) {
                  window.location.href = "/agent/report";
                }
              }}
            >
              Reset Search
            </Button>
          </Grid>
        </Grid>
      </div>

      <Grid
        container
        spacing={2}
        margin={`15px 0px`}
        padding={`10px 15px 0px 0px`}
      >
        <Grid item xs={12} lg={12} md={12} textAlign={`right`}>
          <Button className="btn-primary" onClick={downloadExcel}>
            Export to Excel
          </Button>
        </Grid>

        <Grid item xs={12} lg={12} md={12}>
          <MaterialReactTable
            columns={[
              {
                accessorKey: "ticketID",
                header: "Ticket ID",
                size: 100,
              },
              {
                accessorKey: "ticketSubject",
                header: "Ticket Subject",
                size: 250,
              },
              {
                accessorKey: "emp_no",
                header: "Emp No",
              },
              {
                accessorKey: "emp_name",
                header: "Created User",
              },
              {
                accessorKey: "ticketCategory",
                header: "Category",
              },
              {
                accessorKey: "sub_category",
                header: "Sub Category",
              },
              {
                accessorKey: "statusName",
                header: "Status",
                size: 100,
              },
              {
                accessorKey: "ticketType",
                id: "Prioritization", // ID must match what the SP expects for sorting
                header: "Prioritization",
                size: 100,
              },
              {
                accessorFn: (row) => row.agent_name || "-",
                id: "agent_name",
                header: "IT Admin Name",
              },
              {
                accessorFn: (row) => row.lastAgentReplyDate || "-",
                id: "lastAgentReplyDate",
                header: "Last IT Admin Reply Date",
              },
              {
                accessorFn: (row) => formatAdminTime(row.admin_time),
                id: "admin_time",
                header: "Admin Time",
              },
            ]}
            data={ticketList}
            manualFiltering
            manualPagination
            manualSorting
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              columnFilters,
              globalFilter,
              isLoading: loading,
              pagination,
              sorting,
            }}
            enableGlobalFilter={true}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            enableHiding={false}
            enableStickyHeader={true}
            muiTableContainerProps={{
              sx: {
                maxHeight: '500px', // Set height and enable scrolling
              },
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: "0",
                border: "1px solid #e0e0e0",
              },
            }}
            muiTableHeadCellProps={{
              sx: {
                backgroundColor: "#f5f5f5",
                color: "#333",
                fontWeight: "bold",
              },
            }}
          />
        </Grid>
      </Grid>
    </Layout>
  );
}
